// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (width:768px){
    .section_header_wrapper {
        width: 100%;
        height: 8%;
        /* background-color: #848498; */
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 9px;
    }
    .section_header_wrapper .button_wrapper button {
        display: flex;
        font-size: 9px;
    }
    .section_header_wrapper .paginationWrapper{
        
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 9px;
    }

    .paginationInputWrapper {
        display: flex;
        align-items: center;
        position: relative;
        width: 40%;
        height: 21px;
        border: 1px solid var(--Primary_color);
        border-radius: 3px;
    }
    .paginationInputWrapper .find_btn {
        border: unset;
        background-color: var(--Primary_color);
        padding: 0px 6px;
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
        color: #fff;
    }
    .paginationInputWrapper h6{
        font-size: 9px;
    }
    .logout_box_wrapper .profile_box_wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        background-color: var(--Primary_color);
        gap: 0.938rem;
        padding-left: 0.2rem;
        position: relative;
        transition: 0.3s ease;
    }
    .survey_analysis_tab_wrapper {
        display: flex;
        align-items: normal;
        /* font-size: 12px; */
    }
}
@media screen and (min-width:768px) and (max-width:1023px) {
    .side_nav_section {
        width: 23%;
    }

    .routes_view_section {
        width: 77%;
    }

    .tab {
        padding: 0.375rem 0.188rem 0.375rem 0.425rem;
    }

    .tab .icon {
        margin-right: 0.5rem;
    }

    .tab span,
    .dropdown_tab span {
        font-size: 14px;
    }

    .tab .icon .svg-inline--fa {
        font-size: 0.9rem;
    }

    .dropdown_tab {
        padding: 0.375rem 0.188rem 0.375rem 2rem;
    }

    .dashboard_graph_wrapper canvas {
        height: 350px !important;
    }

    .dashboard_card_wrapper .card_wrapper {
        height: 110px;
        padding: 5px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
    }

    .dashboard_card_wrapper .card_wrapper .inner_card .svg-inline--fa {
        font-size: 15px;
    }

    .dashboard_card_wrapper .card_wrapper .inner_card h6 {
        font-size: 9px;
    }

    .dashboard_card_wrapper .card_wrapper .count h6 {
        font-size: 9px;
    }

    .current_progress_wrap .msi_panel_wrapper {
        width: 90%;
        margin: auto;
    }

    .organization_table {
        min-width: 1400px;
    }

    .table_header h5,
    .table_data h6 {
        font-size: 12px;
    }

    .data_analysis_card_wrapper .survey_card {
        min-width: 40%;
    }

    .survey_analysis_graph_wrapper canvas {
        max-height: 220px;
    }

    .counter_card_wrapper .counter_card {
        width: calc(100% / 5);
    }

    .counter_card_wrapper {
        gap: 8px;
    }

    .counter_card_wrapper .counter_card h6,
    .counter_card_wrapper .counter_card h5 {
        font-size: 12px;
    }

    .msi_panel_wrapper {
        width: 92%;
        margin: auto;
        overflow-y: auto;
    }

    .msi_panel_wrapper .msi_panel_card_wrapper {
        height: 300px;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .download_template_wrapper .card_wrapper {
        min-width: 240px;
    }

    .modal_wrapper .card_wrapper,
    .form_wrapper_main .card_wrapper {
        width: 95%;
    }

    .designation_wrapper .designation_card {
        max-height: 80%;
    }

    .designation_wrapper .check_box_wrapper label {
        font-size: 12px;
        margin-bottom: 0;
    }

    .booth_access_wrapper .add_access_button {
        right: -9%;
    }

    .modal_wrapper .card_body,
    .form_wrapper_main .card_body {
        width: 100%;
        overflow: auto;
    }
}


/* s */
@media screen and (min-width:1440px) {
    .top_header .title {
        font-size: 1rem;
    }

    .table_header h5 {
        font-size: 16px;
    }

    .table_data h6 {
        font-size: 14px;
    }
}

@media screen and (width:2560px) {
    .top_header .title {
        font-size: 1.563rem;
    }

    .table_header h5 {
        font-size: 19px;
    }

    .table_data h6 {
        font-size: 17px;
    }

    .tab .title {
        font-size: 35px;
    }

    .tab .icon {
        margin-right: 1.5rem;
        font-size: 35px;
    }

    .modal_wrapper .card_header .title h5 {
        font-size: 25px;
    }

    .modal_wrapper .card_wrapper, .form_wrapper_main .card_wrapper {
        min-height: 50%
    }

    .modal_wrapper .card_header .close_button, .form_wrapper_main .card_header .close_button {
        width: 30px;
        height: 30px;
    }

    .input_box_wrapper label {
        font-size: 18px;
    }

    .input_box_wrapper input, .input_box_wrapper select, .input_box_wrapper textarea, .react-datepicker-wrapper input {
        font-size: 18px;
    }

    .modal_wrapper .submit_button_wrapper .filter_button, .form_wrapper_main .submit_button_wrapper .filter_button {
        margin-top: 30px;
    }

    .action .action_button {
        font-size: 16px;
        padding: 1px 11px;
    }

    .action_designation .svg-inline--fa {
        font-size: 20px;
    }

}

@media screen and (min-device-width: 1024px) and (max-device-width:2560px) {

    .voting_area_graph_wrapper .svg_wrapper:nth-child(2) {
        top: -10%;
        left: 28%;
        width: 130px;
        height: 110px;
    }

    .voting_area_graph_wrapper .svg_wrapper:nth-child(3) {
        top: 62.3%;
        right: 16.5%;
    }

    .voting_area_graph_wrapper .svg_wrapper:nth-child(4) {
        top: 73%;
        left: -13%;
        width: 150px;
        height: 130px;
    }

    .voting_area_graph_wrapper .svg_wrapper:nth-child(7) {
        top: 145.5%;
        left: -6.4%;
        width: 129px;
        height: 130px;
    }

    .voting_area_graph_wrapper .svg_wrapper:nth-child(9) {
        top: 110%;
        left: 37%;
        width: 104px;
        height: 100px;
    }

    .voting_area_graph_wrapper .svg_wrapper:nth-child(10) {
        top: 94%;
        right: 10%;
    }

    .voting_area_graph_wrapper .svg_wrapper:nth-child(11) {
        top: 230%;
        left: 5%;
    }

    .voting_area_graph_wrapper .svg_wrapper:nth-child(12) {
        top: 180%;
        right: 23%;
        width: 156px;
        height: 95px;
    }

    .voting_area_graph_wrapper .svg_wrapper:nth-child(13) {
        top: 181%;
        right: 13%;
        width: 80px;
        height: 60px;

    }

}`, "",{"version":3,"sources":["webpack://./src/css/mediaQuery.css"],"names":[],"mappings":"AAAA;IACI;QACI,WAAW;QACX,UAAU;QACV,+BAA+B;QAC/B,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,QAAQ;IACZ;IACA;QACI,aAAa;QACb,cAAc;IAClB;IACA;;YAEQ,aAAa;YACb,mBAAmB;YACnB,SAAS;YACT,cAAc;IACtB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,kBAAkB;QAClB,UAAU;QACV,YAAY;QACZ,sCAAsC;QACtC,kBAAkB;IACtB;IACA;QACI,aAAa;QACb,sCAAsC;QACtC,gBAAgB;QAChB,kBAAkB;QAClB,MAAM;QACN,QAAQ;QACR,YAAY;QACZ,WAAW;IACf;IACA;QACI,cAAc;IAClB;IACA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,sCAAsC;QACtC,aAAa;QACb,oBAAoB;QACpB,kBAAkB;QAClB,qBAAqB;IACzB;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,qBAAqB;IACzB;AACJ;AACA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,4CAA4C;IAChD;;IAEA;QACI,oBAAoB;IACxB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,4BAA4B;QAC5B,gCAAgC;IACpC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,QAAQ;IACZ;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;;QAEI,WAAW;QACX,cAAc;IAClB;AACJ;;;AAGA,MAAM;AACN;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,oBAAoB;QACpB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;AAEA;;IAEI;QACI,SAAS;QACT,SAAS;QACT,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,QAAQ;QACR,UAAU;QACV,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,SAAS;QACT,SAAS;QACT,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;;IAEA;QACI,SAAS;QACT,QAAQ;IACZ;;IAEA;QACI,SAAS;QACT,UAAU;QACV,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,SAAS;QACT,UAAU;QACV,WAAW;QACX,YAAY;;IAEhB;;AAEJ","sourcesContent":["@media screen and (width:768px){\n    .section_header_wrapper {\n        width: 100%;\n        height: 8%;\n        /* background-color: #848498; */\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        gap: 9px;\n    }\n    .section_header_wrapper .button_wrapper button {\n        display: flex;\n        font-size: 9px;\n    }\n    .section_header_wrapper .paginationWrapper{\n        \n            display: flex;\n            align-items: center;\n            gap: 10px;\n            font-size: 9px;\n    }\n\n    .paginationInputWrapper {\n        display: flex;\n        align-items: center;\n        position: relative;\n        width: 40%;\n        height: 21px;\n        border: 1px solid var(--Primary_color);\n        border-radius: 3px;\n    }\n    .paginationInputWrapper .find_btn {\n        border: unset;\n        background-color: var(--Primary_color);\n        padding: 0px 6px;\n        position: absolute;\n        top: 0;\n        right: 0;\n        height: 100%;\n        color: #fff;\n    }\n    .paginationInputWrapper h6{\n        font-size: 9px;\n    }\n    .logout_box_wrapper .profile_box_wrapper {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        align-items: center;\n        background-color: var(--Primary_color);\n        gap: 0.938rem;\n        padding-left: 0.2rem;\n        position: relative;\n        transition: 0.3s ease;\n    }\n    .survey_analysis_tab_wrapper {\n        display: flex;\n        align-items: normal;\n        /* font-size: 12px; */\n    }\n}\n@media screen and (min-width:768px) and (max-width:1023px) {\n    .side_nav_section {\n        width: 23%;\n    }\n\n    .routes_view_section {\n        width: 77%;\n    }\n\n    .tab {\n        padding: 0.375rem 0.188rem 0.375rem 0.425rem;\n    }\n\n    .tab .icon {\n        margin-right: 0.5rem;\n    }\n\n    .tab span,\n    .dropdown_tab span {\n        font-size: 14px;\n    }\n\n    .tab .icon .svg-inline--fa {\n        font-size: 0.9rem;\n    }\n\n    .dropdown_tab {\n        padding: 0.375rem 0.188rem 0.375rem 2rem;\n    }\n\n    .dashboard_graph_wrapper canvas {\n        height: 350px !important;\n    }\n\n    .dashboard_card_wrapper .card_wrapper {\n        height: 110px;\n        padding: 5px;\n        border-top-left-radius: 10px;\n        border-bottom-right-radius: 10px;\n    }\n\n    .dashboard_card_wrapper .card_wrapper .inner_card .svg-inline--fa {\n        font-size: 15px;\n    }\n\n    .dashboard_card_wrapper .card_wrapper .inner_card h6 {\n        font-size: 9px;\n    }\n\n    .dashboard_card_wrapper .card_wrapper .count h6 {\n        font-size: 9px;\n    }\n\n    .current_progress_wrap .msi_panel_wrapper {\n        width: 90%;\n        margin: auto;\n    }\n\n    .organization_table {\n        min-width: 1400px;\n    }\n\n    .table_header h5,\n    .table_data h6 {\n        font-size: 12px;\n    }\n\n    .data_analysis_card_wrapper .survey_card {\n        min-width: 40%;\n    }\n\n    .survey_analysis_graph_wrapper canvas {\n        max-height: 220px;\n    }\n\n    .counter_card_wrapper .counter_card {\n        width: calc(100% / 5);\n    }\n\n    .counter_card_wrapper {\n        gap: 8px;\n    }\n\n    .counter_card_wrapper .counter_card h6,\n    .counter_card_wrapper .counter_card h5 {\n        font-size: 12px;\n    }\n\n    .msi_panel_wrapper {\n        width: 92%;\n        margin: auto;\n        overflow-y: auto;\n    }\n\n    .msi_panel_wrapper .msi_panel_card_wrapper {\n        height: 300px;\n        overflow-y: auto;\n        overflow-x: hidden;\n    }\n\n    .download_template_wrapper .card_wrapper {\n        min-width: 240px;\n    }\n\n    .modal_wrapper .card_wrapper,\n    .form_wrapper_main .card_wrapper {\n        width: 95%;\n    }\n\n    .designation_wrapper .designation_card {\n        max-height: 80%;\n    }\n\n    .designation_wrapper .check_box_wrapper label {\n        font-size: 12px;\n        margin-bottom: 0;\n    }\n\n    .booth_access_wrapper .add_access_button {\n        right: -9%;\n    }\n\n    .modal_wrapper .card_body,\n    .form_wrapper_main .card_body {\n        width: 100%;\n        overflow: auto;\n    }\n}\n\n\n/* s */\n@media screen and (min-width:1440px) {\n    .top_header .title {\n        font-size: 1rem;\n    }\n\n    .table_header h5 {\n        font-size: 16px;\n    }\n\n    .table_data h6 {\n        font-size: 14px;\n    }\n}\n\n@media screen and (width:2560px) {\n    .top_header .title {\n        font-size: 1.563rem;\n    }\n\n    .table_header h5 {\n        font-size: 19px;\n    }\n\n    .table_data h6 {\n        font-size: 17px;\n    }\n\n    .tab .title {\n        font-size: 35px;\n    }\n\n    .tab .icon {\n        margin-right: 1.5rem;\n        font-size: 35px;\n    }\n\n    .modal_wrapper .card_header .title h5 {\n        font-size: 25px;\n    }\n\n    .modal_wrapper .card_wrapper, .form_wrapper_main .card_wrapper {\n        min-height: 50%\n    }\n\n    .modal_wrapper .card_header .close_button, .form_wrapper_main .card_header .close_button {\n        width: 30px;\n        height: 30px;\n    }\n\n    .input_box_wrapper label {\n        font-size: 18px;\n    }\n\n    .input_box_wrapper input, .input_box_wrapper select, .input_box_wrapper textarea, .react-datepicker-wrapper input {\n        font-size: 18px;\n    }\n\n    .modal_wrapper .submit_button_wrapper .filter_button, .form_wrapper_main .submit_button_wrapper .filter_button {\n        margin-top: 30px;\n    }\n\n    .action .action_button {\n        font-size: 16px;\n        padding: 1px 11px;\n    }\n\n    .action_designation .svg-inline--fa {\n        font-size: 20px;\n    }\n\n}\n\n@media screen and (min-device-width: 1024px) and (max-device-width:2560px) {\n\n    .voting_area_graph_wrapper .svg_wrapper:nth-child(2) {\n        top: -10%;\n        left: 28%;\n        width: 130px;\n        height: 110px;\n    }\n\n    .voting_area_graph_wrapper .svg_wrapper:nth-child(3) {\n        top: 62.3%;\n        right: 16.5%;\n    }\n\n    .voting_area_graph_wrapper .svg_wrapper:nth-child(4) {\n        top: 73%;\n        left: -13%;\n        width: 150px;\n        height: 130px;\n    }\n\n    .voting_area_graph_wrapper .svg_wrapper:nth-child(7) {\n        top: 145.5%;\n        left: -6.4%;\n        width: 129px;\n        height: 130px;\n    }\n\n    .voting_area_graph_wrapper .svg_wrapper:nth-child(9) {\n        top: 110%;\n        left: 37%;\n        width: 104px;\n        height: 100px;\n    }\n\n    .voting_area_graph_wrapper .svg_wrapper:nth-child(10) {\n        top: 94%;\n        right: 10%;\n    }\n\n    .voting_area_graph_wrapper .svg_wrapper:nth-child(11) {\n        top: 230%;\n        left: 5%;\n    }\n\n    .voting_area_graph_wrapper .svg_wrapper:nth-child(12) {\n        top: 180%;\n        right: 23%;\n        width: 156px;\n        height: 95px;\n    }\n\n    .voting_area_graph_wrapper .svg_wrapper:nth-child(13) {\n        top: 181%;\n        right: 13%;\n        width: 80px;\n        height: 60px;\n\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
